import { render, staticRenderFns } from "./SampleClassificationNoise.vue?vue&type=template&id=0f0fe532&scoped=true"
import script from "./SampleClassificationNoise.vue?vue&type=script&lang=js"
export * from "./SampleClassificationNoise.vue?vue&type=script&lang=js"
import style0 from "./SampleClassificationNoise.vue?vue&type=style&index=0&id=0f0fe532&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0fe532",
  null
  
)

export default component.exports